// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"54c523fb","419":"e5b70d2d","563":"81b99b7c","787":"9a5fdcda","942":"7518cae3"}[chunkId] + ".chunk.js";
};